import { c as _c } from "react/compiler-runtime";
import React, { useCallback } from "react";
import { useTranslations } from "modules/i18n/hooks/useTranslations";
import { usePageProps } from "common/hooks/data/usePageProps";
import type { AppProps } from "common/lib/getAppServerSideProps";
import { navigateWindowLocation } from "@theconversation/shared-libraries/windowLocation";
export const RegionDropdown = () => {
  "use memo";

  const $ = _c(12);
  const {
    activeRegions,
    regionCode
  } = usePageProps();
  const t = useTranslations("layout.header");
  const onRegionChange = _temp;
  let t0;
  if ($[0] !== t) {
    t0 = t("edition");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <label htmlFor="mobile-region-dropdown" className="mb-1 block text-sm font-bold">{t0}:</label>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== activeRegions) {
    t2 = activeRegions.map(_temp2);
    $[4] = activeRegions;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== regionCode || $[7] !== t2) {
    t3 = <div className="group w-full rounded-sm border border-gray-400 p-2 hover:bg-gray-50 has-[:focus-visible]:outline-2 has-[:focus-visible]:outline-offset-2 has-[:focus-visible]:outline-blue-700"><select id="mobile-region-dropdown" value={regionCode} onChange={onRegionChange} className="w-full bg-white text-sm outline-none group-hover:bg-gray-50">{t2}</select></div>;
    $[6] = regionCode;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t3) {
    t4 = <div className="m-4">{t1}{t3}</div>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
function _temp(event) {
  navigateWindowLocation(`/${event.target.value}`);
}
function _temp2(t0) {
  const {
    code,
    nameInRegionLanguage
  } = t0;
  return <option value={code} key={code}>{nameInRegionLanguage}</option>;
}